import {createContext,useContext,useEffect,useRef,useState} from 'react';
import Api from '../services/api';
import {startPush} from '../services/push';
const Auth=createContext(null);
export const useAuth=()=>useContext(Auth);
export function AuthProvider({initialUser=null,children}) {
  const [user,setUser]=useState(initialUser),[loading,setLoading]=useState(!initialUser),[error,setError]=useState(''),[connected,setConnected]=useState(false);
  const revision=useRef(0);
  useEffect(()=>{
    let alive=true;
    const update=account=>{Api.user=account;if(alive)setUser(account);document.dispatchEvent(new CustomEvent('account-changed',{detail:account}));};
    Api.user=initialUser;
    Api.desktopClientId=Api.createUploadKey();
    Api.setUser=account=>{revision.current++;update(account);};
    Api.onUnauthorized=()=>{Api.user=null;if(alive)setUser(null);document.dispatchEvent(new Event('desktop-notifications-stop'));};
    Api.refreshAccount=async()=>{const current=++revision.current;const data=await Api.request('/api/me');if(current!==revision.current)return Api.user;Api.csrfToken=data.csrfToken;update(data.user);return data.user;};
    Api.ready=Api.refreshAccount().catch(failure=>{if(failure.status!==401 && alive)setError(failure.message);return null;}).finally(()=>{if(alive)setLoading(false);});
    return ()=>{alive=false;};
  },[]);
  useEffect(()=>{
    if(!user || loading)return;
    setConnected(true);
    const dispatch=name=>document.dispatchEvent(new Event(name));
    const refresh=()=>{Api.refreshAccount().catch(()=>{});['orders-changed','customers-changed','notifications-changed','sessions-changed'].forEach(dispatch);};
    const visible=()=>{if(!document.hidden)refresh();};
    document.addEventListener('visibilitychange',visible);
    const pushController=new AbortController(),pushCleanup=startPush(pushController.signal).catch(()=>()=>{});
    return ()=>{
      pushController.abort();
      document.removeEventListener('visibilitychange',visible);
      setConnected(false);
      pushCleanup.then(clean=>clean?.());
    };
  },[user?.id,user?.branchId,loading]);
  return <Auth.Provider value={{user,loading,error,connected}}>{children}</Auth.Provider>;
}
